export default {
  license: {
    license_manage_title: '许可证管理',
    btn_apply: '申请许可证',
    btn_import: '导入许可证',
    probation_title: '您处于正常试用中',
    probation_desc: '当前软件为试用期，为不影响您的使用效果，请于 {date} 前导入有效的许可证',
    probation_over_desc: '您的试用期已过，请导入有效的许可证',
    upload_format_error: '请导入.lic文件',
    upload_lic_success: '导入成功！',
    upload_lic_fail: '导入失败！',
    license_expired: '许可证已到期，请联系管理员申请授权',
    license_probation_expired: '已过试用期，请联系管理员申请许可证',
    license_popup_title: '提示信息',
    client: {
      client_info_title: '客户信息',
      owner: '许可证所有人',
      status: '状态',
      id: '许可证序列号',
      generate_date: '生成日期',
      valid_date: '有效日期',
      product: '授权产品',
      robot_num: '授权机器人数量',
      used_robot: '已使用机器人数量',
      authorized_info: '授权信息',
      expired: '已过期',
      valid: '有效',
      open: '开启',
      close: '关闭',
      faq_amount: 'FAQ数量',
      kg_entity: 'KG实体',
      te_scenerio: 'TE场景',
      chat_function: '闲聊功能',
      ner_function: 'NER功能',
      function: '技能发现',
      probation_expired: '试用期结束',
      probation_valid: '试用期有效',
      license_expired: '已过期',
      license_valid: '有效',
      authorized_list_title: '授权产品列表',
    },
    authorized_status: {
      title: '授权使用状态',
      robot_used_status: '授权机器人总数{total}个 已使用{num}个',
      robot_name: '机器人名称',
      robot_num: '机器人数量',
      user_name: '用户名',
      amount: '使用量',
      opened: '已开启',
      not_open: '未开启',
      used: '已使用',
      not_use: '未使用',
      concurrent: '并发数量',
      total_file_count: '总文件数',
      amount_per_day: '每天最大文件数',
      total_length: '总时长(h)',
      length_per_day: '每天最大时长(h)',
      online_num: '坐席在线数量',
      short_text: '短文本标注',
      long_text: '长文本标注',
      daily_call: '每日调用次数',
      tts_num: '语音识别数量',
      asr_num: '语音合成数量',
    },
    apply: {
      popup_title: '许可证申请',
      apply_steps: '申请步骤',
      steps: '["1. 点击按钮生成机器码", "2. 将机器码发送给你的客户经理", "3. 竹间许可证管理员会在收到机器码3个工作日内，核实信息之后生成许可证，发送至您邮箱", "4. 您查收邮件后下载许可证书，在BFOP平台上传导入"]',
      generate_code: '生成机器码',
      generating_code: '机器码生成中',
      generate_success: '生成成功！',
      generate_fail: '生成失败！',
      machine_code: '机器码',
      generated_tips: '机器码已生成，请进行复制/下载后将机器码信息发送至support@emotibot.com 会有工作人员处理后邮件回复进度',
      generated_tips_fail: '机器码生成失败,请十分钟之后重试',
      file_name: '授权码',
      copy_success: '复制成功',
      empty_code: '机器码为空！',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn-license.js